import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigationType, useParams } from "react-router";
import { resetAllSlices } from "../fileBrowser/store/utils";
export const shouldReset = ({ currentFileId, previousFileId, navigationType, }) => {
    return (previousFileId !== undefined &&
        currentFileId !== previousFileId &&
        navigationType === "PUSH");
};
/* Resets file browser slices when user navigates away from file browser. */
const useResetFileBrowserSlices = () => {
    const { fileId } = useParams();
    const navigationType = useNavigationType();
    const dispatch = useDispatch();
    const previousFileIdRef = useRef(fileId);
    useEffect(() => {
        if (shouldReset({
            currentFileId: fileId,
            previousFileId: previousFileIdRef.current,
            navigationType: navigationType,
        })) {
            dispatch(resetAllSlices());
        }
        previousFileIdRef.current = fileId;
    }, [navigationType, fileId, dispatch]);
};
export default useResetFileBrowserSlices;
//# sourceMappingURL=useResetFileBrowserSlices.js.map